import './WageItem.css';
import React from 'react';
import {connect} from 'react-redux';
import * as _ from 'lodash';

import FontAwsome from 'react-fontawesome';
import * as ReactDataGrid from 'react-data-grid';
import {Editors, Formatters} from 'react-data-grid-addons';

import {Box} from 'reactjs-admin-lte';
import {
  Table,
  Row,
  Col,
  Form,
  FormControl,
  ControlLabel,
  FormGroup,
  Button,
  Radio,
} from 'react-bootstrap';

import {
  loadWageList,
} from '../../../../stores/CarDamage/WageReducer';
import {
  updateDamageItemByWageItem,
} from '../../../../stores/CarDamage/DamageReducer';
import {
  setCarSize,
} from '../../../../stores/CarDamage/CarReducer';
import NewWageItemModal from './../NewWageItemModal/NewWageItemModal';
import CheckboxEditor from './../Editors/CheckboxEditor';

class WageItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      new_wage_modal: false,
    };
  }

  changeCarSize = (carSize) => (e) => {
    const {props} = this;
    props.dispatch(setCarSize({carSize: carSize}));
  };

  renderTableData() {
    const {props, state} = this;
    const {dispatch, car} = props;

    return (
        <div>
          <div className="table-responsive form-group"
               style={{maxHeight: '400px', overflow: 'auto'}}>
            <table
                className={'table table-bordered table-striped table-hover table-bordered-solid'}>
              <thead>
              <tr>
                <th className={'nowrap'}>รายการค่าแรง</th>
                <th className={'nowrap'}>Labor</th>
                <th style={{width: '80px'}}
                    className={'nowrap text-center'}>เคาะ-พ่นสี
                </th>
                <th style={{width: '80px'}}
                    className={'nowrap text-center'}>ซ่อม
                </th>
              </tr>
              </thead>
              <tbody>
              {props.wageList.map(
                  (item, index) => this.renderTableRow(item, index))}
              </tbody>
            </table>
          </div>
          <FormGroup>
            <NewWageItemModal show={state.new_wage_modal} {...car}
                              onSave={_ => dispatch(loadWageList(car))}
                              onHide={_ => this.setState(
                                  {new_wage_modal: false})}
            />
            <Button bsStyle={'success'}
                    onClick={_ => this.setState({new_wage_modal: true})}
            >+ เพิ่มรายการ</Button>
          </FormGroup>
        </div>
    );
  }

  updateItem = (item, field) => (e) => {
    let updated = {
      detail: item.description,
      wage_itemnum: item.itemnum,
      [field]: e.target.checked && 1 || 0,
    };
    this.props.dispatch(updateDamageItemByWageItem({
      itemnum: item.itemnum,
      updated,
    }));
  };

  renderTableRow(item, index) {
    const {props} = this;
    const {damageList} = props;

    const paint_checked = !!_.find(damageList,
        damageItem =>
            item.itemnum == damageItem.wage_itemnum
            && damageItem.paint_flag == 1,
    );
    const fix_checked = !!_.find(damageList,
        damageItem =>
            item.itemnum == damageItem.wage_itemnum
            && damageItem.fix_flag == 1,
    );

    return (
        <tr key={index}
            className={
              [(paint_checked || fix_checked ? 'success' : '')].join(' ')
            }>
          <td>{item.description}</td>
          <td>{item.description_en}</td>
          <td className={'text-center'}>
            <input type={'checkbox'}
                   onChange={this.updateItem(item, 'paint_flag')}
                   checked={paint_checked} />
          </td>
          <td className={'text-center'}>
            <input type={'checkbox'}
                   onChange={this.updateItem(item, 'fix_flag')}
                   checked={fix_checked} />
          </td>
        </tr>
    );
  }

  render() {
    const {props} = this;
    const {dispatch} = props;
    const {car} = props;
    const {carSize} = car;
    return (
        <div className={'car-part-stock-list'}>
          <Box loading={props.loading.wage}>
            <Box.Body>
              <FormGroup>
                <span
                    className="label label-default car-info">
                  {props.car.carDetail}
                  </span>
              </FormGroup>
              <FormGroup>
                <ControlLabel>
                  <FontAwsome name={'car'} /> ขนาดรถ
                </ControlLabel>{' '}
                {['S', 'M', 'L'].map((item, index) => (
                    <Radio key={index} inline
                           name={'carSize'}
                           value={item}
                           onChange={this.changeCarSize(item)}
                           checked={carSize.toString().toLowerCase() ==
                                    item.toString().
                                        toLowerCase()}>{item}</Radio>
                ))}
                <span>*(ค่าแรงบางรายการขึ้นอยู่กับขนาดรถ)</span>
              </FormGroup>
              {props.car.partID <= 0
                  ? 'เลือกตำแหน่ง 1-13 จุดเสียหายเพื่อแสดงชิ้นส่วนอะไหล่'
                  : <div>{this.renderTableData()}</div>
              }
            </Box.Body>
          </Box>
        </div>
    );
  }
}

export default connect(
    (state, props) => ({...state, ...props}),
)(WageItem);


// WEBPACK FOOTER //
// ./src/component/element/CarDamageForm/WageItem/WageItem.js